import { FC, Suspense } from 'react';
import { LayoutSpinner } from '@mybonum/ui';
import { Outlet } from 'react-router';

import { AuthorizedHeader } from './components/header';
import { Sidebar } from './components/sidebar';

import styles from './styles.module.scss';

import { useProfileContext } from '@/contexts/profile';
import { SidebarProvider } from '@/contexts/sidebar';
import { useAuthRedirect } from '@/hooks';

export const AuthorizedLayout: FC = () => {
    const { loading } = useProfileContext();
    useAuthRedirect();

    return (
        <SidebarProvider>
            <div className={styles.layout}>
                <Sidebar className={styles.sidebar} />
                <AuthorizedHeader className={styles.header} />
                <main className={styles.content}>
                    {loading ? (
                        <LayoutSpinner />
                    ) : (
                        <Suspense fallback={<LayoutSpinner />}>
                            <Outlet />
                        </Suspense>
                    )}
                </main>
            </div>
        </SidebarProvider>
    );
};
